export enum EnumDivisa {
  EUR = 1,
  USD,
  GBP
}
